<template>
    <div class="col-lg-8 mx-auto">
        <header class="text-center">
            <workflow-navigation workflowStage="Life" />
            <div class="col-lg-10 mx-auto mb-4">
                <h2 class="skin-page-heading">
                    Have you thought about how long you'll need your retirement savings to last?
                </h2>
                <p>
                    None of us know exactly how long we'll live in retirement, but getting a better
                    idea can help you plan with more confidence. Many people are surprised to learn
                    just how long that might be!
                </p>
            </div>
        </header>

        <SubSection v-if="usesSurvivabilityForLifeExpectancy" title="How far might your money need to go?" :show-help="false">
            <survivability @complete="registerStepCompletion" />
        </SubSection>
        <SubSection v-else title="Your health" :show-help="false">
            <health-state @complete="registerStepCompletion" />
        </SubSection>

        <page-nav back-link="personaldetails" @next-clicked="onNextClicked" :parent-will-handle-next="true" :next-link="nextLink" />
        
        <contact-us class="mt-5"></contact-us>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import WorkflowNavigation from "@/guiide/components/common/WorkflowNavigation.vue";
import ContactUs from "./common/ContactUs.vue";
import PageNav from "@/guiide/components/common/PageNav.vue";
import SubSection from "@/guiide/components/common/SubSection.vue";
import { useStore } from "vuex";
import { workflow } from "../ts/workflow/workflow";
import View from "../ts/view";
import LifeExpectancyBasis from "../ts/lifeExpectancyBasis";
import HealthState from "@/guiide/components/lifeexpectancy/HealthState.vue";
import Survivability from "@/guiide/components/lifeexpectancy/Survivability.vue";

const store = useStore();
const nextLink = ref("");
let stepCompleted = false;

const usesSurvivabilityForLifeExpectancy = store.state.configuration?.lifeExpectancyBasis == LifeExpectancyBasis.Survival;

onMounted(async () => {
  const nextWorkflowStep = await workflow.getNextWorkflowStep(View.Life);
  nextLink.value = nextWorkflowStep.resource;
});

function registerStepCompletion() {
  stepCompleted = true;
}

async function onNextClicked() {
  if (!stepCompleted) {
    return;
  }

  await workflow.goToNextWorkflowStep();
}
</script>
